// appListSlice.js

import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  data: null,
  loading: false,
  error: null,
};

// Create a slice
export const searchAppListSlice = createSlice({
  name: 'searchAppList',
  initialState,
  reducers: {
    fetchDataStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const { fetchDataStart, fetchDataSuccess, fetchDataFailure } = searchAppListSlice.actions;
export default searchAppListSlice.reducer;
